import React, { useContext, useEffect, useState} from 'react';
import { MsalContext } from "../../Auth/msal-context";
import { FeatureClickTracker} from '../../Helpers/FeatureHelpers';

import {Navbar, Nav } from 'react-bootstrap';

import PawLogo from '../../images/PawLogo.png';

export default function Header(props){

    const { logout } = useContext(MsalContext);

    return (
        <header >
            <Navbar collapseOnSelect expand="lg" variant="dark" className="pt-0 pb-0">
              <Navbar.Brand href="/"><img src={PawLogo} alt="fetch logo - dog pointing to the right"/><span>Fetch</span></Navbar.Brand>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="mr-auto">
                </Nav>
                <Nav>
                  <Nav.Link onClick={() => { props.additionalView(); FeatureClickTracker("Analytics")} }>Analytics</Nav.Link>
                  <Nav.Link onClick={() => { props.showFeedbackModal(); FeatureClickTracker("Feedback")} }>Feedback</Nav.Link>
                  <Nav.Link onClick={() => logout()}>Logout</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </header>
    );
}